import React, { useEffect, useState } from "react";
import PieceRamaceDesktop from "./PieceRamaceDesktop";
import PieceRamaceMobile from "./PieceRamaceMobile";

const detectMobile = () => {
  if (typeof navigator !== "undefined" && navigator.userAgent) {
    if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      return true;
    }
  }

  if (typeof window !== "undefined") {
    return window.innerWidth <= 900;
  }

  return false;
};

const PieceRamace = () => {
  const [isMobile, setIsMobile] = useState(() => detectMobile());

  useEffect(() => {
    const onResize = () => setIsMobile(detectMobile());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return isMobile ? <PieceRamaceMobile /> : <PieceRamaceDesktop />;
};

export default PieceRamace;
